<footer class="tw-mx-6 tw-flex tw-items-center tw-justify-end tw-gap-2 tw-py-2">
  <a
    href="https://www.mindlife.net"
    target="_blank"
    class="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-border-border tw-bg-muted/50 tw-px-3 tw-py-1 tw-text-xs !tw-text-muted-foreground tw-no-underline tw-transition-colors hover:tw-bg-muted"
    >
    <img
      src="/assets/img/logos/mindlife-logo.webp"
      alt="MindLife"
      class="tw-h-3 tw-w-auto"
      />
    <span class="tw-font-text">&copy; MindLife</span>
    <span class="tw-text-muted-foreground" aria-hidden="true">·</span>
    <span class="tw-font-mono tw-text-[10px]">{{ buildNumber }}</span>
  </a>
  @if (envLabel) {
    <span
      class="tw-inline-flex tw-items-center tw-rounded-full tw-px-2 tw-py-0.5 tw-font-mono tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider"
      style="background: var(--q-yellow-bg); color: var(--q-yellow-text); border: 1px solid var(--q-yellow);"
    >{{ envLabel }}</span>
  }
</footer>
